/**
 * Logs user's action
 */
export default function logAction(category: string, action: string, accountId: number) {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', 'https://log.workshopbutler.com/alltrainings/');
  xhr.send(JSON.stringify({
    account_id: accountId,
    host: window.location.host,
    category,
    action,
  }));
}
